<template>
	<control-button :useConfirm="useConfirm" :comfirmMessage="comfirmMessage" :comfirmOkText="comfirmOkText"
		:comfirmCancelText="comfirmCancelText" class="add-button" @buttonClick="buttonClick">
		<i class="el-icon-plus add-button-icon"></i>
		<slot></slot>
	</control-button>
</template>

<script>
	import {defineComponent} from "vue"
	import controlButton from "@/components/controlButton.vue"

	export default defineComponent({
		name: "addButton",
		components: {
			controlButton
		},
		props: {
			useConfirm: {
				type: Boolean,
				default: false
			},
			comfirmMessage: {
				type: String,
				default: "这是一段内容确定删除吗？"
			},
			comfirmOkText: {
				type: String,
				default: "好的"
			},
			comfirmCancelText: {
				type: String,
				default: "不用了"
			}
		},
		emits:["buttonClick"],
		setup(props, {emit}){
			let methods ={
				buttonClick() {
					emit("buttonClick")
				}
			}
			
			return {
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.add-button {
		box-sizing: border-box;
		@include border_all("add-button-border");
		@include font_color("add-button-font-color");
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: space-around;

		.add-button-icon {
			margin-right: 10px;
		}
	}
</style>
